/**
 * Created by Ninghai on 2017/12/26.
 */
/**
 * 常量设置
 */
export const expireTime = 1000 * 60 * 60 * 3  // 过期时间

/**
 * 服务器地址
 * @type {string}
 */
// export const serviceUrl = 'https://beta.ssymmetry.com'
// java接口地址
// export const javaServiceUrl = 'https://betaj.ssymmetry.com/web/beta'
export const serviceUrl = 'https://www.ssymmetry.com'
// export const serviceUrl = 'https://www.ssymmetry.com'
export const javaServiceUrl = 'https://betaj.ssymmetry.com/web/v1'
// export const javaServiceUrl = 'http://localhost:8001/web/v1'
// api用户接口
export const javaServiceUrl1 = 'https://betaj.ssymmetry.com/userapi'
// 本地测试
// export const javaServiceUrl1 = 'http://localhost:8009/userapi'
export const javaServiceUrl2 = 'https://betaj.ssymmetry.com/backStageManagement'
// export const javaServiceUrl1 = 'https://161.189.144.84:8009/userapi'

export const javaServiceUrl3 = 'https://codebbt.ssymmetry.com'

/**
 * echarts基础设置
 */
export const testColorCollection = ['#0875ba', '#7c80ad', '#9CC2B0', '#6D9EA8', '#698570', '#3385ff', '#4bc2f0', '#325B69', '#4c4686', '#C98769', '#B03A5B', '#42b983', '#efd689', '#AE5548', '#fb8a51', '#ca8622', '#c23531']
export const chartColorCollection = ['#0875ba', '#7c80ad', '#4bc2f0', '#3385ff', '#91BEC3', '#4c4686', '#906651', '#fb8a51', '#709894c9', '#50f7e6c9']
export const categoryColorCollectionIint = ['#1f4e79', '#00b0f0', '#a5a5a5', '#e7e6e6', '#4472c4', '#ff0000', '#255e91', '#8faadc', '#636363', '#dae3f3', '#264478', '#c00000', '#7cafdd', '#2f5597', '#b7b7b7', '#798ed0', '#8cc168', '#327dc2', '#848484']
export const categoryColorCollection = (function () {
  let copyArr = []
  for (let i = 0; i < 8; i++) {
    copyArr = copyArr.concat(categoryColorCollectionIint)
  }
  return copyArr
}(categoryColorCollectionIint))
export const basicColor = '#0875ba'
export const basicGrid = {x: 50, y: 35, x2: 45, y2: 35, borderWidth: 0}
export const basicDataZoom = [{type: 'inside', start: 0, end: 100}]
export const chartNoDataStyle = {
  text: '暂无数据...',
  color: basicColor,
  textColor: '#333',
  maskColor: 'rgba(255, 255, 255, 1.0)'
}
export const chartLoadingStyle = {
  text: '加载中...',
  color: basicColor,
  textColor: '#333',
  maskColor: 'rgba(255, 255, 255, 1.0)'
}

// 设置错误信息过期时间
export const messageExpireTime = 2000

// 常见错误信息
export const commenErrorMessage = {}

// 所有产品类型
export const productTypes = ['ashare', 'ocs', 'unlisted', 'custom']



// WEBPACK FOOTER //
// ./src/utils/constant.js